import { ActionType } from "@sp-crm/core";
import React from "react";
import { Route, Switch } from "react-router";
import { useIsAllowedInWholeTenant } from "store/selectors/hooks";
import { ManageUsersEdit } from "../manage-users/manage-users-edit";
import { ManageIntegrationsList } from "./manage-integrations-list";

export const ManageIntegrationAccounts: React.FC<unknown> = props => {
    const manageIntegrationsAllowed = useIsAllowedInWholeTenant(
        ActionType.ManageIntegrations,
    );
    if (!manageIntegrationsAllowed) {
        return null;
    }
    return (
        <Switch>
            <Route
                exact
                path="/settings/integrations/accounts"
                component={ManageIntegrationsList}
            />
            <Route
                path="/settings/integrations/accounts/:userId"
                component={ManageUsersEdit}
            />
        </Switch>
    );
};
